<div class="content-header-container">
  @if (breadcrumbs()) {
    <div class="content-container breadcrumb-container">
      @for (breadcrumb of breadcrumbs(); track $index) {
        <div class="breadcrumb-item" (click)="breadcrumbClicked(breadcrumb)">
          @if (breadcrumb.iconName) {
            <mat-icon class="breadcrumb-icon" [svgIcon]="breadcrumb.iconName"></mat-icon>
          }
          <div class="breadcrumb-title">
            {{ breadcrumb.title }}
          </div>
        </div>
        <div class="breadcrumb-separator">
          <mat-icon [svgIcon]="'chevron-right'"></mat-icon>
        </div>
      }
    </div>
  }
  <div class="content-container header-content">
    <ng-content></ng-content>
  </div>
</div>
